import React from 'react';
import {MainView} from "./MainView";
import {ContextProvider} from "./ContextProvider";

export const EDISetupDetails=()=>{

    return(
        <ContextProvider>
                <MainView />
        </ContextProvider>


    );
}